/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import {
  Navigate,
  useAppSelector,
  parseJWT,
  useLocation,
  Outlet,
  MENUS,
  some,
  useSwitchEmployers,
  useGetPermissions,
} from '@lib/index';
import { SCOPES } from '@config/index';
import { PrivateRouteProps, DecodedJWT } from './types';

const PrivateRoute = ({ roles, permission }: PrivateRouteProps) => {
  const { currentUser } = useAppSelector((state) => state.account);
  const location = useLocation();
  const decodedJWT: DecodedJWT = parseJWT(currentUser.kitchen as string);
  const { siteEmployers } = useSwitchEmployers();

  if (decodedJWT && decodedJWT.exp * 1000 < Date.now()) {
    return <Navigate to="/logout" state={{ from: location }} replace />;
  }
  if (!currentUser.kitchen) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  const permissions = useGetPermissions();
  const f30IsPresent = some(
    siteEmployers,
    (siteEmployer) => siteEmployer.config?.f30?.includes(SCOPES.canViewRegularContractorF30Page),
  );

  if (
    permission
    && siteEmployers?.length < 2
    && !permissions?.includes(MENUS[permission as keyof typeof MENUS])
  ) {
    return <Navigate to="/not-found" state={{ from: location }} replace />;
  }
  if (permission && siteEmployers?.length > 1 && !f30IsPresent) {
    return <Navigate to="/not-found" state={{ from: location }} replace />;
  }
  if (!roles?.includes(currentUser?.role)) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
